import { Map } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useMiniTour } from "@/components/tour/MiniTourProvider";

interface GuideButtonProps {
  pageKey: string;
  /**
   * When true, hide the "Guide" text label below the `sm` breakpoint so the
   * button condenses to just its icon on phones — mirrors ExplainerVideoButton.
   */
  compactOnMobile?: boolean;
}

export function GuideButton({ pageKey, compactOnMobile = false }: GuideButtonProps) {
  const { hasGuide, startGuide } = useMiniTour();

  if (!hasGuide(pageKey)) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => startGuide(pageKey)}
      className="flex items-center gap-1.5 text-emerald-600 border-emerald-200 hover:bg-emerald-50 hover:border-emerald-300 dark:text-emerald-400 dark:border-emerald-700 dark:hover:bg-emerald-900/20 dark:hover:border-emerald-600 shrink-0"
      data-testid={`button-guide-${pageKey}`}
      title={compactOnMobile ? "Interactive Guide" : undefined}
    >
      <Map className="h-4 w-4" />
      <span className={compactOnMobile ? "hidden sm:inline" : undefined}>
        Guide
      </span>
    </Button>
  );
}
